import { Flex, Heading, Text } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';

import getSelectedTicketPrice from './utils/getSelectedTicketPrice';

// enhance this function until we support other currency
const renderAmountWithCurrency = ({ amount, currency }: any) => {
  if (currency === 'NTD') {
    return `NT$${amount}`;
  }

  return `US$${amount}`;
};

const OrderBlock = ({ selectedTicket, quantity, checkoutAmount }: any) => {
  const { t } = useTranslation(['common']);

  return (
    <Flex
      flex={3}
      bg="gray.100"
      p={4}
      position={{ base: 'relative', md: 'sticky' }}
      top={{ base: 'unset', md: '10%' }}
      h="fit-content"
      flexDirection="column"
    >
      <Heading as="h4" fontSize="lg">
        {t('Your Order')}
      </Heading>
      {selectedTicket && (
        <>
          <Flex
            justifyContent="space-between"
            borderBottom="1px"
            borderColor="gray.300"
            mt={4}
            pb={4}
          >
            <Text>
              {selectedTicket.name} x {quantity}
            </Text>
            <Text>
              {getSelectedTicketPrice({ selectedTicket, quantity }) > 0 ? (
                <>
                  {renderAmountWithCurrency({
                    amount: getSelectedTicketPrice({
                      selectedTicket,
                      quantity,
                    }),
                    currency: selectedTicket.currency,
                  })}
                </>
              ) : (
                t('Free')
              )}
            </Text>
          </Flex>
          <Flex mt={4} justifyContent="space-between">
            <Text fontSize="lg">{t('Total')}</Text>
            <Text fontSize="lg" fontWeight="bold">
              {renderAmountWithCurrency({
                amount: checkoutAmount,
                currency: selectedTicket.currency,
              })}
            </Text>
          </Flex>
        </>
      )}
    </Flex>
  );
};

export default OrderBlock;
